"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPlaceTopPlace = void 0;
exports.defaultPlaceTopPlace = {
    id: 1,
    name: 'Positano Discovery Bay',
    caption: '愉景灣悅堤',
    image: 'https://images.okay.com/Property/Folder150/296974_636718501594729307.jpg',
    link: '#hi'
};
